import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LOCALES } from './locales';

type NamespaceResources = Record<string, Record<string, unknown>>;
type LocaleResources = Record<string, NamespaceResources>;

const localeModules = import.meta.glob('./locales/*/*.json', {
  eager: true,
}) as Record<string, { default: Record<string, unknown> }>;

const resources: LocaleResources = {};
const namespaceSet = new Set<string>();

for (const [path, mod] of Object.entries(localeModules)) {
  const match = path.match(/^\.\/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!match) continue;
  const locale = match[1]!;
  const namespace = match[2]!;
  resources[locale] ??= {};
  resources[locale][namespace] = mod.default;
  namespaceSet.add(namespace);
}

const namespaces = Array.from(namespaceSet).sort();

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: 'common',
    ns: namespaces,
    interpolation: { escapeValue: false },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lngs, ns, key) => {
      if (import.meta.env.DEV) {
        console.warn(`[i18n] missing key: ${ns}:${key}`);
      }
    },
  });

export default i18n;
